import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import agent from "../../../agent";
import {
  Asset,
  VIPDonationToken,
  GeneralProject,
} from "../../../interface/Server";
import { reducer } from "../../../context";
import actionType from "../../../context/actionType";
import Api from "../../../helpers/Api";
import { logResponse } from "../../../helpers/Logger";

import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import {
  FormControl,
  InputGroup,
  Col,
  Button,
  Row,
  Container,
} from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import AssetListItem from "../../assets/screens/AssetListScreen/components/AssetList/Sections/ListItems/AssetListItem";
import GeneralProjectItem from "../../assets/screens/AssetListScreen/components/AssetList/Sections/ListItems/GeneralProjectItem";
import { Warning } from "../FormScreenStyles";
import FormDropdown from "../FormDropdown";
import ErrorBox from "../../../components/ErrorBox/ErrorBox";
import googleKeys from "../../../configs/googleKeys";
import { SmallText } from "../../../components/Text";
import { isInvalidSession, resetSession } from "../../../helpers/ErrorHandler";

// TributeTypeEnum
const PREFIX_OPTIONS = [
  "Supported by",
  "In honour of",
  "In memory of",
  "Anonymous",
];

const ASSET_ICON_PATH = {
  tree: "/donation/assets/icons/treePlaque.png",
  bench: "/donation/assets/icons/benchPlaque.png",
  block: "/donation/assets/icons/blockPlaque.png",
} as { [key: string]: string };

let captchaRef: any;

function extractParamsByUrl(url: string): string[] {
  const paths = window.location.href.split("/");
  const splitIndex = paths.indexOf("vipDonation");
  const params = paths.slice(splitIndex + 1);
  return [params[0], params[1], params[2]];
}

const onSelectProjectCallback = (
  project: GeneralProject,
  formReducer: any,
  configReducer: any
) => {
  project.images = [project.image];

  formReducer.dispatch({
    type: actionType.form.START_FORM_STAGE,
    payload: {
      selectedProject: project,
    },
  });
  const auth = sessionStorage.getItem("auth");
  const headers = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: "" + auth,
  };

  console.info("onSelectProjectCallback");

  console.info(project);

  fetch(`${Api.path(window.location)}generalProject/${project.projectId}`, {
    method: "GET",
    headers,
  })
    .then(function (response) {
      if (response.status === 401) {
        throw "Invalid Session";
      }
      return response.json();
    })
    .then((resJson) => {
      console.info("Project Json");
      console.info(resJson);

      logResponse(
        configReducer.state.debugMode,
        `vipDonation: generalProject: ${resJson.msg}`
      );
      if (isInvalidSession(resJson)) {
        throw "Invalid Session";
      }
      if (resJson.msg == "OK") {
        sessionStorage.setItem(
          "SELECTED_PROJECT",
          JSON.stringify(resJson.data)
        );

        console.info("SELECTED_PROJECT --- " + JSON.stringify(resJson.data));

        sessionStorage.removeItem("SELECTED_ASSET");
      }
    })
    .catch(() => {
      resetSession(formReducer);
    });
};

const onSelectAssetCallback = (
  asset: Asset,
  formReducer: any,
  configReducer: any
) => {
  formReducer.dispatch({
    type: actionType.form.START_FORM_STAGE,
    payload: {
      selectedAsset: asset,
    },
  });
  const auth = sessionStorage.getItem("auth");
  const headers = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: "" + auth,
  };
  fetch(`${Api.path(window.location)}/asset/${asset.assetId}`, {
    method: "GET",
    headers: headers,
  })
    .then(function (response) {
      if (response.status === 401) {
        throw "Invalid Session";
      }
      return response.json();
    })
    .then((resJson) => {
      logResponse(
        configReducer.state.debugMode,
        `vipDonation: asset/\{id\}: ${resJson.msg}`
      );
      if (isInvalidSession(resJson)) {
        //        throw "Invalid Session";
      }
      if (resJson.msg == "OK") {
        sessionStorage.setItem("SELECTED_ASSET", JSON.stringify(resJson.data));
        sessionStorage.removeItem("SELECTED_PROJECT");
      }
    })
    .catch(() => {
      //      resetSession(formReducer);
    });
};

const VIPDonation: React.FunctionComponent<RouteComponentProps> = (props) => {
  const { formReducer, configReducer } = useContext(reducer);
  const [isGeneralProject, setIsGeneralProject] = useState(false);
  const titleOptions = isGeneralProject
    ? PREFIX_OPTIONS.slice(1)
    : PREFIX_OPTIONS;
  const [verified, setVerified] = useState(false);
  const [tributeName, setTributeName] = useState("");
  const [tributeAmount, setTributeAmount] = useState(0);
  const [tributeAmountEmpty, setTributeAmountEmpty] = useState(false);
  const [tributeType, setTributeType] = useState(PREFIX_OPTIONS[1]);
  const [error, setError] = useState({
    blockedName: false,
    blockedAsset: false,
  });

  const [gProjectID, setGProjectID] = useState("");

  const { t, i18n } = useTranslation();
  const [recaptchaLg, setRecaptchaLg] = useState(
    i18n.language === "en" ? "en" : "zh-TW"
  );

  const onSelectProjectCallback = (
    project: GeneralProject,
    formReducer: any,
    configReducer: any
  ) => {
    project.images = [project.image];

    formReducer.dispatch({
      type: actionType.form.START_FORM_STAGE,
      payload: {
        selectedProject: project,
      },
    });
    const auth = sessionStorage.getItem("auth");
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "" + auth,
    };

    console.info("onSelectProjectCallback");

    console.info(project);

    fetch(`${Api.path(window.location)}generalProject/${project.projectId}`, {
      method: "GET",
      headers,
    })
      .then(function (response) {
        if (response.status === 401) {
          throw "Invalid Session";
        }
        return response.json();
      })
      .then((resJson) => {
        logResponse(
          configReducer.state.debugMode,
          `vipDonation: generalProject: ${resJson.msg}`
        );
        if (isInvalidSession(resJson)) {
          // throw "Invalid Session";
          // Zekta: Temp disable general project's session timeout code
        }
        if (resJson.msg == "OK") {
          sessionStorage.setItem(
            "SELECTED_PROJECT",
            JSON.stringify(resJson.data)
          );

          console.info("SELECTED_PROJECT --- " + JSON.stringify(resJson.data));
          console.info(resJson.data);
          setGProjectID(resJson.data.projectId.toString(0));

          sessionStorage.removeItem("SELECTED_ASSET");
        }
      })
      .catch(() => {
        //        resetSession(formReducer);
      });
  };

  function queryVIPDonation(
    accessKey: string,
    donationId: string,
    routerProps: RouteComponentProps,
    formReducer: any,
    configReducer: any,
    setTributeAmount: any
  ) {
    agent.auth.vipDonation({ accessKey, donationId }).then((res: any) => {
      if (!res || !(res.msg == "OK")) {
        // invalid response go back to AssetListScreen
        toast.error(
          `${
            res.msg || "Error getting donation details"
          }. Redirecting to asset list.`
        );
        routerProps.history.replace("/");
        return;
      }
      const token = res.data as VIPDonationToken;
      // save asset info to session storage for pre-fill
      console.log("vipDonation response: ", token);
      // store nameplate and donation form info for prefill
      sessionStorage.setItem(
        "SESSION_EMAIL",
        token.personalInfo.primaryEmail || ""
      );
      sessionStorage.setItem(
        "SESSION_TOKEN",
        JSON.stringify(token.personalInfo)
      );

      if (token.vipGreeting) {
        sessionStorage.setItem("VIP_GREETING", token.vipGreeting);
      }

      if (token.amount) {
        sessionStorage.setItem("VIP_AMOUNT", token.amount);
      }

      if (token && token.amount) {
        setTributeAmount(token.amount);
      }

      sessionStorage.setItem(
        "SESSION_NAMEPLATE",
        JSON.stringify(token.nameplate)
      );
      formReducer.dispatch({
        type: actionType.form.SET_SCREEN,
        payload: {
          screen: "nameplate",
        },
      });
      if (token.projectType === "Asset") {
        const asset = token.project as Asset;
        onSelectAssetCallback(asset, formReducer, configReducer);
      }
      if (token.projectType === "General") {
        const project = token.project as GeneralProject;
        onSelectProjectCallback(project, formReducer, configReducer);
      }
    });
  }

  useEffect(() => {
    // get :accessKey/:donationId from props.match (RouteComponentProps)
    if (props && props.match && props.match.params) {
      const { accessKey, donationId, type } = props.match.params as {
        [key: string]: any;
      };
      if (type === "General") {
        setIsGeneralProject(true);
      } else {
        setIsGeneralProject(false);
      }
      if (accessKey && donationId) {
        queryVIPDonation(
          accessKey,
          donationId,
          props,
          formReducer,
          configReducer,
          setTributeAmount
        );
      }
    } else if (window.location.href.length) {
      // fall back use URL to extract params
      const [accessKey, donationId, type] = extractParamsByUrl(
        window.location.href
      );
      if (accessKey && donationId) {
        queryVIPDonation(
          accessKey,
          donationId,
          props,
          formReducer,
          configReducer,
          setTributeAmount
        );
      }
    }
  }, []);

  function loadTributeFromSession(nameplateStorage: any) {
    const prefill = JSON.parse(nameplateStorage);
    const parsedType = prefill.tributeType
      ? `${prefill.tributeType}${
          prefill.tributeType === "Anonymous" ? "" : "..."
        }`
      : PREFIX_OPTIONS[1];
    setTributeType(parsedType);
    setTributeName(prefill.tributeName || "");
  }

  useEffect(() => {
    if (tributeType !== "Anonymous" && !tributeName) {
      const nameplateStorage = sessionStorage.getItem("SESSION_NAMEPLATE");
      if (nameplateStorage) loadTributeFromSession(nameplateStorage);
    }
    if (tributeType === "Anonymous") {
      setTributeName("");
    }
  }, [
    tributeType,
    formReducer.state.selectedAsset,
    formReducer.state.selectedProject,
  ]);

  useEffect(() => {
    // load token contents from VIP Donation API to state TODO
  }, [formReducer.state.selectedAsset, formReducer.state.selectedProject]);

  useEffect(() => {
    setRecaptchaLg(i18n.language === "en" ? "en" : "zh-TW");
    if (captchaRef && captchaRef.reset) {
      captchaRef.reset();
    }
  }, [i18n.language]);

  const recaptchaValidation = (token: string) => {
    const auth = sessionStorage.getItem("auth");
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "" + auth,
    };
    fetch(
      `${Api.path(
        window.location
      )}/common/recaptcha?g-recaptcha-response=${token}&purpose=nameplate`,
      {
        method: "GET",
        headers: headers,
      }
    )
      .then((result) => {
        if (result.status === 401) {
          throw "Invalid Session";
        }
        return result.json();
      })
      .then((resJson) => {
        logResponse(
          configReducer.state.debugMode,
          `common/recaptcha: ${resJson.msg}`
        );
        if (isInvalidSession(resJson)) {
          //          throw "Invalid Session";
        }
        if (resJson.msg == "OK") {
          setVerified(true);
        } else {
          if (captchaRef && captchaRef.reset) {
            captchaRef.reset();
          }
        }
      })
      .catch(() => {
        //        resetSession(formReducer);
      });
  };
  const callNameplateApi = (name: string, tributeType: string) => {
    const auth = sessionStorage.getItem("auth");
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: "" + auth,
    };
    // remove ellipsis from prefix or set to null for Anonymous due to TributeTypeEnum check
    const sanitiseTributeType =
      tributeType === "Anonymous" ? null : tributeType.replace("...", "");
    fetch(`${Api.path(window.location)}/donate/nameplate`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        tributeName: name,
        tributeType: sanitiseTributeType,
      }),
    })
      .then((result) => {
        if (result.status === 401) {
          throw "Invalid Session";
        }
        return result.json();
      })
      .then((resJson) => {
        logResponse(
          configReducer.state.debugMode,
          `donate/nameplate: ${resJson.msg}`
        );
        if (isInvalidSession(resJson)) {
          //          throw "Invalid Session";
        }
        if (resJson.msg == "OK") {
          setVerified(true);

          // TODO: check if local check for empty tributeName necessary
          if (props.history && props.history.push) {
            formReducer.dispatch({
              type: actionType.form.SET_USERNAME,
              payload: {
                // use form
                userName: "", //`${requestData.firstName} ${requestData.lastName}`
              },
            });
            props.history.push("/auth/payment/confirm");
          }
        }
        if (resJson.msg == "blocked") {
          // name plaque name is blocked, please choose another
          setError({
            blockedAsset: false,
            blockedName: true,
          });
        }
        // response.result returned false, failed, display error message
        // toast.error(resJson.msg || 'Unknown error sending request, please try again.');
        if (
          resJson.msg == "Fail to lock the asset, please choose another one."
        ) {
          // asset has been selected / blocked
          setError({
            blockedAsset: true,
            blockedName: false,
          });
        }
        if (captchaRef && captchaRef.reset) {
          captchaRef.reset();
        }
      })
      .catch(() => {
        //        resetSession(formReducer);
      });
  };

  useEffect(() => {
    const nameplateStorage = sessionStorage.getItem("SESSION_NAMEPLATE");
    if (nameplateStorage) loadTributeFromSession(nameplateStorage);
  }, []);

  const handleNameplateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    // setVerified(false); // change of text, need to re-verify
    // if(captchaRef && captchaRef.reset) {
    //     captchaRef.reset();
    // }
    const NOT_WS_EN_ZH_REGEX_MATCH =
      /[^\s\w\u2E80-\u2FD5\u3190-\u319f\u3400-\u4DBF\u4E00-\u9FCC\uF900-\uFAAD]/gi;
    setTributeName(
      event.target.value.replace
        ? event.target.value.replace(NOT_WS_EN_ZH_REGEX_MATCH, "")
        : event.target.value
    );
  };

  const handleAmountChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTributeAmountEmpty(false);
    setTributeAmount(
      Number(
        event.target.value.replace
          ? event.target.value.replace(/\D/g, "")
          : event.target.value
      )
    );
  };

  useEffect(() => {
    if (error.blockedAsset) {
      setTimeout(() => {
        window.location.href = "/";
      }, 5000);
    }
  }, [error.blockedAsset]);

  // Confirm Name Plaque Button
  const renderButton = (style = {}) => (
    <Button
      size={"lg"}
      onClick={() => {
        if (isGeneralProject && !tributeAmount) {
          setTributeAmountEmpty(true);
          return;
        }
        sessionStorage.setItem(
          "DONATION_AMOUNT",
          JSON.stringify(tributeAmount)
        );
        callNameplateApi(tributeName, tributeType);
      }}
      variant={"primary"}
      disabled={!verified}
      style={{
        ...style,
        width: "301px",
        height: "57px",
        backgroundColor: "#2c3e50",
        color: verified ? "#FFFFFF" : "#78848f",
        borderColor: "#2c3e50",
      }}
    >
      {t("confirm")}
    </Button>
  );

  const assetType =
    formReducer.state.selectedAsset && formReducer.state.selectedAsset.type;
  let assetPath = ASSET_ICON_PATH.block; // default or unknown asset type
  let paddingAmt = 20;
  let imageMaxWidth = 420;
  let imageMinWidth = 400;
  let color = "#000000";
  var searchParams = new URLSearchParams(document.location.search);
  if (assetType === "Tree") {
    color = "#ffffff";
    assetPath = ASSET_ICON_PATH.tree;
    imageMaxWidth = 320;
    imageMinWidth = 280;
  }
  if (assetType === "Bench") {
    assetPath = ASSET_ICON_PATH.bench;
    imageMaxWidth = 500;
    imageMinWidth = 460;
  }
  if (isMobile) {
    imageMaxWidth = imageMaxWidth * 0.8;
    imageMinWidth = imageMinWidth * 0.8;
  }

  return (
    <Container>
      <Helmet>
        <meta
          property="og:description"
          content="Name plaque description and name"
        />
      </Helmet>
      <div
        style={{
          fontFamily: "Rambla",
          fontSize: "1.4rem",
          display: "flex",
          borderStyle: "solid",
          borderWidth: "0px 0px 1px 0px",
          borderColor: "black",
          paddingTop: "10px",
        }}
      >
        {t("selectedItem")}
      </div>
      <Row style={{ margin: 0, padding: 0 }}>
        <Col style={{ margin: 0, padding: 0 }}>
          {formReducer.state.selectedAsset && (
            <AssetListItem
              displayImage
              asset={formReducer.state.selectedAsset}
              hideButton
              nameplateDisplay
              isMobile={isMobile}
            />
          )}

          {formReducer.state.selectedProject && (
            <GeneralProjectItem
              item={formReducer.state.selectedProject}
              hideButton
              nameplateDisplay
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <Row
            style={{
              padding: 0,
              margin: 0,
              marginBottom: 16,
              ...(isMobile ? { flexDirection: "column" } : {}),
            }}
          >
            {/* {!searchParams.has('generalProject') && 
                            <div style={{ display: 'flex', minWidth: '10vw', marginRight: 15, ...(isMobile ? { marginTop: 12 } : {})}}>
                                <FormDropdown
                                    options={titleOptions}
                                    menuStyle={{ backgroundColor: '#6c757d', minWidth: 150, height: 38, borderRadius: '.25rem', ...(isMobile ? { maxWidth: '45vw' } : { maxWidth: '12vw' }) }}
                                    textStyle={{ color: 'white', fontFamily: 'Rambla', fontSize: '100%' }}
                                    currentSelection={t(tributeType) || tributeType}
                                    placeholder=""
                                    language={i18n.language}
                                    onClick={(tributeType: any) => setTributeType(tributeType)}
                                />
                            </div>
                        } */}
            <div
              style={{
                display: "flex",
                flex: 1,
                ...(isMobile
                  ? { marginTop: 12 }
                  : searchParams.has("generalProject")
                  ? {}
                  : { marginLeft: 15 }),
                ...(isGeneralProject ? { flexDirection: "column" } : {}),
              }}
            >
              <InputGroup
                style={{
                  width: "100%",
                  ...(gProjectID != null &&
                  gProjectID != "" &&
                  !["2", "3", "4", "5"].includes(gProjectID)
                    ? {}
                    : { display: "none" }),
                }}
              >
                <InputGroup.Prepend>
                  <InputGroup.Text style={{ fontFamily: "Rambla" }}>
                    {isGeneralProject
                      ? t("acknowledgementName")
                      : t("nameplaque")}
                    {gProjectID}
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  style={{ fontFamily: "Rambla" }}
                  disabled={tributeType === "Anonymous"}
                  onChange={(event: any) => handleNameplateChange(event)}
                  value={tributeName}
                  placeholder={`${t(
                    tributeType === "Anonymous"
                      ? "thankYouSupport"
                      : "displayName"
                  )}`}
                  aria-label="email"
                />
              </InputGroup>
              {isGeneralProject ? (
                <Row style={{ padding: 0, margin: 0, marginTop: 16 }}>
                  <div
                    style={{
                      display: "flex",
                      flex: 1,
                      flexDirection: "column",
                    }}
                  >
                    <InputGroup>
                      <InputGroup.Prepend>
                        <InputGroup.Text style={{ fontFamily: "Rambla" }}>
                          {t("amountHKD")}
                        </InputGroup.Text>
                      </InputGroup.Prepend>
                      <FormControl
                        style={{
                          fontFamily: "Rambla",
                          ...(tributeAmountEmpty ? { borderColor: "red" } : {}),
                        }}
                        onChange={(event: any) => handleAmountChange(event)}
                        value={tributeAmount ? tributeAmount.toString() : ""}
                        placeholder={`${t("donationAmount")}`}
                        maxLength={15}
                      />
                    </InputGroup>
                    {tributeAmountEmpty && (
                      <Warning style={{ marginTop: 8 }}>
                        {t("invalidDonationAmount")}
                      </Warning>
                    )}
                  </div>
                </Row>
              ) : null}
            </div>
          </Row>
        </Col>
      </Row>
      {!isGeneralProject && (
        <Row>
          <Col>
            <SmallText>{t("nameplaqueFootnote1")}</SmallText>
            <SmallText>{t("nameplaqueFootnote2")}</SmallText>
            <SmallText>
              <b>{t("nameplaqueFootnote3")}</b> {t("nameplaqueFootnote4")}
            </SmallText>
          </Col>
        </Row>
      )}
      {!!error.blockedName && (
        <ErrorBox style={{ marginTop: 16 }}>
          <SmallText style={{ color: "#6b6b6b" }}>
            {t("errorNameplate")}
          </SmallText>
        </ErrorBox>
      )}
      {!!error.blockedAsset && (
        <ErrorBox style={{ marginTop: 16 }}>
          <SmallText style={{ color: "#6b6b6b" }}>
            {t("errorFailLockAsset")}
          </SmallText>
        </ErrorBox>
      )}

      {!isGeneralProject ? (
        <div
          style={{
            minHeight: isMobile ? 320 : 460,
            minWidth: isMobile ? 320 : 540,
            backgroundImage: `url(${assetPath})`,
            backgroundSize: "contain",
            overflowWrap: "break-word",
            backgroundRepeat: "no-repeat",
            textAlign: "center",
            color,
            backgroundPosition: "center",
            marginBottom: 24,
            ...(isMobile
              ? {}
              : {
                  marginTop: 32,
                }),
          }}
        >
          {isMobile ? (
            <h5 style={{ fontFamily: "Rambla", paddingTop: 80 }}>
              {tributeType === "Anonymous" ? "" : t(tributeType)}
            </h5>
          ) : (
            <h3
              style={{ fontFamily: "Rambla", marginBottom: 30, paddingTop: 80 }}
            >
              {tributeType === "Anonymous" ? "" : t(tributeType)}
            </h3>
          )}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              paddingLeft: paddingAmt,
              paddingRight: paddingAmt,
            }}
          >
            {isMobile ? (
              <div style={{ minWidth: imageMinWidth, maxWidth: imageMaxWidth }}>
                <SmallText
                  style={{
                    color,
                    fontFamily: "Rambla",
                    fontSize: 16,
                    wordBreak: "break-all",
                    wordWrap: "break-word",
                  }}
                >
                  {tributeType === "Anonymous"
                    ? t("Anonymous")
                    : tributeName && tributeName.length > 80
                    ? tributeName.slice(0, 79)
                    : tributeName}
                </SmallText>
              </div>
            ) : (
              <div style={{ minWidth: imageMinWidth, maxWidth: imageMaxWidth }}>
                <h1
                  style={{
                    fontSize: 32,
                    fontFamily: "Rambla",
                    wordBreak: "break-all",
                    wordWrap: "break-word",
                  }}
                >
                  {tributeType === "Anonymous"
                    ? t("Anonymous")
                    : tributeName && tributeName.length > 80
                    ? tributeName.slice(0, 79)
                    : tributeName}
                </h1>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div
          style={{
            minHeight: isMobile ? 160 : 230,
            minWidth: isMobile ? 160 : 270,
            backgroundImage: `url(/assets/icons/Name-Plaque-GD.jpg)`,
            backgroundSize: "contain",
            overflowWrap: "break-word",
            backgroundRepeat: "no-repeat",
            textAlign: "center",
            color,
            backgroundPosition: "center",
            marginBottom: 24,
            ...(isMobile
              ? {}
              : {
                  marginTop: 32,
                }),

            /* Hide demo */
            display: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              paddingLeft: paddingAmt,
              paddingRight: paddingAmt,
            }}
          >
            {isMobile ? (
              <div style={{ minWidth: 200, maxWidth: 200, marginTop: 105 }}>
                <SmallText
                  style={{
                    color: "#fff",
                    fontFamily: "Rambla",
                    fontSize: 16,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {tributeType === "Anonymous"
                    ? t("Anonymous")
                    : tributeName && tributeName.length > 80
                    ? tributeName.slice(0, 79)
                    : tributeName}
                </SmallText>
              </div>
            ) : (
              <div style={{ minWidth: 200, maxWidth: 200, marginTop: 105 }}>
                <h1
                  style={{
                    color: "#fff",
                    fontSize: 32,
                    fontFamily: "Rambla",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                >
                  {tributeType === "Anonymous"
                    ? t("Anonymous")
                    : tributeName && tributeName.length > 80
                    ? tributeName.slice(0, 79)
                    : tributeName}
                </h1>
              </div>
            )}
          </div>
        </div>
      )}
      {!isGeneralProject ? (
        <SmallText>{t("footnoteTimeout")}</SmallText>
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          <SmallText>{t("acknowledgementNameWillPlace")}</SmallText>
        </div>
      )}
      <Row
        style={
          isMobile
            ? { justifyContent: "center" }
            : {
                alignItems: "center",
                justifyContent: "flex-end",
                padding: 0,
                margin: 0,
                marginTop: 16,
              }
        }
      >
        <ReCAPTCHA
          // hl={recaptchaLg}
          ref={(ref: any) => (captchaRef = ref)}
          sitekey={googleKeys.PRO_ReCAPTCHA_KEY}
          onChange={(newToken: string | null) => {
            recaptchaValidation(newToken || "");
          }}
        />
        {renderButton(isMobile ? { marginTop: 12 } : { marginLeft: 30 })}
      </Row>
    </Container>
  );
};

export default withRouter(VIPDonation);
